/* MINIBIRK: complete native-market results, then inclusive cm/price bounds. */
(() => {
  if (window.MBRangeFilters) return;
  const PREFIX = 'mb_range_', axes = ['l', 'w', 'h', 'price'], boundNames = ['min','max'];
  const boundKeys = axes.flatMap(a => boundNames.map(b => PREFIX+a+'_'+b));
  const cache = new Map(), bound = new WeakSet(), overlayLabels = new WeakMap();
  let dimensionsPromise, initialGeneration = 0, initialController, ownApplyPending=false;
  function panel(root=document) { return root.querySelector('[data-mb-ranges]'); }
  function words(p) { return JSON.parse(p.querySelector('[data-mb-copy-json]').content.textContent); }
  function message(copy, key, currency) { return (copy[key] || key).replaceAll('{currency}',currency); }
  function number(value) {
    if (value === null || value.trim() === '') return null;
    const normalized = value.trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(normalized)) throw new Error('invalid_number');
    const n = Number(normalized);
    if (!Number.isFinite(n) || n < 0 || n > 1e9) throw new Error('invalid_number');
    return n;
  }
  function ranges(params) {
    return Object.fromEntries(axes.map(a => {
      const min=number(params.get(PREFIX+a+'_min')), max=number(params.get(PREFIX+a+'_max'));
      if (min!==null && max!==null && min>max) throw new Error('invalid_range');
      return [a,{min,max}];
    }));
  }
  function active(params) { return boundKeys.some(k=>params.get(k)?.trim()); }
  function within(value, range) { return Number.isFinite(value) && (range.min===null || value>=range.min) && (range.max===null || value<=range.max); }
  function matches(row, r, index) {
    const dim=index[row.id];
    for (const a of ['l','w','h']) {
      if (r[a].min===null && r[a].max===null) continue;
      if (!dim || dim.sku!==row.sku || dim.ean!==row.ean || dim.hashes[row.locale]!==row.fingerprint || !within(dim[a],r[a])) return false;
    }
    return (r.price.min===null && r.price.max===null) || row.prices.some(p=>within(p/100,r.price));
  }
  function fill(p, params) {
    const copy=words(p), currency=p.dataset.currency;
    p.querySelectorAll('[data-mb-copy]').forEach(el=>el.textContent=message(copy,el.dataset.mbCopy,currency));
    p.querySelectorAll('[data-mb-axis]').forEach(input=>{
      input.value=params.get(input.name)||'';
      input.setAttribute('aria-label',message(copy.aria,input.dataset.mbAria,currency));
    });
    p.querySelector('[data-mb-clear]').hidden=!active(params);
  }
  function error(p,key) {
    const el=p.querySelector('[data-mb-error]'); el.textContent=message(words(p),key,p.dataset.currency);el.hidden=false;
    p.querySelector('[data-mb-status]').textContent='';
    p.querySelector('[data-mb-apply]').disabled=false;
  }
  function loading(p) {
    p.querySelector('[data-mb-error]').hidden=true;
    p.querySelector('[data-mb-status]').textContent=words(p).loading;
    p.querySelector('[data-mb-apply]').disabled=true;
  }
  async function fetchPage(url, signal, expected, expectedPage) {
    const response=await fetch(url,{signal,credentials:'same-origin'});
    if (!response.ok) throw new Error('load_error');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const template=doc.querySelector('template[data-mb-filter-data]');
    if (!template) throw new Error('load_error');
    const data=JSON.parse(template.content.textContent);
    if (data.currency!==expected.currency || data.country!==expected.country || data.locale!==expected.locale || data.page!==expectedPage || !Array.isArray(data.rows)) throw new Error('load_error');
    return data;
  }
  async function nativeWalk(query,p,signal) {
    const expected={currency:p.dataset.currency,country:p.dataset.country,locale:p.dataset.locale};
    const url=location.pathname+'?'+query.toString();
    const first=await fetchPage(url,signal,expected,1); let data=first, rows=[...first.rows], page=1;
    if(first.total!==first.source_total)throw new Error('load_error');
    if (!Number.isInteger(first.pages) || first.pages>100 || first.total>10000) throw new Error('load_error');
    while(page<first.pages) {
      if(!data.next) throw new Error('load_error');
      const next=new URL(data.next,location.origin+location.pathname);if(next.origin!==location.origin || next.pathname!==location.pathname) throw new Error('load_error');
      next.searchParams.set('view','mb-filter-data');
      const selection=k=>['q','type','sort_by'].includes(k)||k.startsWith('filter.')||k.startsWith('options[');
      const canonical=q=>JSON.stringify(Array.from(q.entries()).filter(([k])=>selection(k)).sort((a,b)=>(a[0]+'='+a[1]).localeCompare(b[0]+'='+b[1])));
      if(canonical(next.searchParams)!==canonical(query))throw new Error('load_error');
      // Shopify omits tracking/preview/country parameters from pagination links.
      for(const k of Array.from(next.searchParams.keys()))if(!selection(k)&&k!==(first.page_param||'page')&&k!=='view')next.searchParams.delete(k);
      for(const [k,value] of query)if(!selection(k)&&k!==(first.page_param||'page')&&k!=='view')next.searchParams.append(k,value);
      data=await fetchPage(next,signal,expected,++page);
      if(data.total!==first.total || data.source_total!==first.source_total || data.pages!==first.pages) throw new Error('load_error');
      rows.push(...data.rows);
    }
    if(rows.length!==first.total) throw new Error('load_error');
    return {rows,total:first.total};
  }
  function remember(key,rows) {
    const result={rows,at:Date.now(),key};cache.set(key,result);
    while(cache.size>8)cache.delete(cache.keys().next().value);
    return result;
  }
  async function allRows(params,p,signal) {
    const query=new URLSearchParams(params);boundKeys.forEach(k=>query.delete(k));query.delete(PREFIX+'currency');
    query.delete('section_id');query.delete('page');query.set('view','mb-filter-data');
    const url=location.pathname+'?'+query.toString(), key=p.dataset.country+'/'+p.dataset.locale+'/'+p.dataset.currency+'/'+url;
    if(cache.has(key)&&Date.now()-cache.get(key).at<120000)return cache.get(key);
    if(p.dataset.pageType!=='search'){
      const data=await nativeWalk(query,p,signal),rows=data.rows.filter(Boolean);
      if(rows.length!==data.total||new Set(rows.map(r=>r.id)).size!==rows.length)throw new Error('load_error');
      return remember(key,rows);
    }
    // Search price ties can repeat boundary IDs. Two complete opposite walks
    // must jointly contain exactly the native product-only result count.
    const ascending=new URLSearchParams(query),descending=new URLSearchParams(query);
    ascending.set('type','product');descending.set('type','product');
    ascending.set('sort_by','price-ascending');descending.set('sort_by','price-descending');
    const walks=await Promise.all([nativeWalk(ascending,p,signal),nativeWalk(descending,p,signal)]);
    if(walks[0].total!==walks[1].total)throw new Error('load_error');
    const union=new Map(),identity=r=>JSON.stringify([r.sku,r.ean,r.locale,r.fingerprint,r.prices]);
    for(const data of walks)for(const row of data.rows){
      if(!row||!/^\d+$/.test(row.id)||!Array.isArray(row.prices)||!row.prices.length||row.prices.some(n=>!Number.isFinite(n)||n<0))throw new Error('load_error');
      if(union.has(row.id)&&identity(union.get(row.id))!==identity(row))throw new Error('load_error');
      if(!union.has(row.id))union.set(row.id,row);
    }
    if(union.size!==walks[0].total)throw new Error('load_error');
    const direction=query.get('sort_by')==='price-descending'?-1:1;
    const rows=Array.from(union.values()).sort((a,b)=>direction*(Math.min(...a.prices)-Math.min(...b.prices))||(BigInt(a.id)<BigInt(b.id)?-1:BigInt(a.id)>BigInt(b.id)?1:0));
    return remember(key,rows);
  }
  async function index(p, signal) {
    if(!dimensionsPromise) dimensionsPromise=fetch(p.dataset.indexUrl).then(r=>{if(!r.ok)throw new Error('load_error');return r.json();}).then(r=>r.products).catch(e=>{dimensionsPromise=null;throw e;});
    return dimensionsPromise;
  }
  function resultLabel(copy,count) { return count===1?copy.results_one:copy.results_many.replace('{count}',String(count)); }
  function render(root, rows, p, r, params, key) {
    const wrapper=root.querySelector('.collection-wrapper'), copy=words(p);
    let list=root.querySelector('#collection');
    if(!list) {
      list=document.createElement('ul');list.id='collection';list.className='l4cl w25 w50-mobile with-quick-buy';
      const host=root.querySelector('.results')||wrapper.querySelector(':scope > div');
      if(!host) throw new Error('load_error');host.append(list);
    }
    root.querySelectorAll('[data-mb-native-pagination]').forEach(el=>el.hidden=true);
    const resultHost=root.querySelector('.results');
    if(resultHost) Array.from(resultHost.children).forEach(el=>{if(el!==list && !el.contains(list))el.remove();});
    wrapper.dataset.standardResultsCount=rows.length;
    root.querySelectorAll('[data-mb-result-count]').forEach(el=>el.textContent=resultLabel(copy,rows.length));
    root.querySelectorAll('[data-mb-result-count-number]').forEach(el=>el.textContent='('+rows.length+')');
    root.querySelectorAll('[data-mb-summary], [data-mb-more]').forEach(el=>el.remove());
    const summary=document.createElement('div');summary.className='mb-range-summary';summary.dataset.mbSummary='';summary.setAttribute('role','status');
    const heading=document.createElement('p');heading.textContent=rows.length?resultLabel(copy,rows.length):copy.no_results;summary.append(heading);
    const selections=document.createElement('small');
    const fmt=new Intl.NumberFormat(p.dataset.locale,{maximumFractionDigits:2});
    selections.textContent=axes.filter(a=>r[a].min!==null||r[a].max!==null).map(a=>{
      const title=a==='price'?message(copy,'price_currency',p.dataset.currency):copy[{l:'length_cm',w:'width_cm',h:'height_cm'}[a]];
      return title+': '+(r[a].min===null?'≤ '+fmt.format(r[a].max):r[a].max===null?'≥ '+fmt.format(r[a].min):fmt.format(r[a].min)+'–'+fmt.format(r[a].max));
    }).join(' · '); summary.append(selections);if(p.dataset.pageType==='search'){const notice=document.createElement('small');notice.textContent=copy.filtered_search_price_sort_notice;summary.append(notice);}list.before(summary);
    list.innerHTML=rows.slice(0,48).map(row=>row.html).join('');
    const result={rows,at:Date.now(),key};cache.set('filtered:'+key,result);
    wrapper.dataset.mbFilteredKey='filtered:'+key;wrapper.dataset.mbVisible=String(Math.min(rows.length,48));
    if(rows.length>48){const more=document.createElement('button');more.type='button';more.className='mb-range-more';more.dataset.mbMore='';more.textContent=copy.load_more;list.after(more);}
    if(!rows.length){const help=document.createElement('p');help.textContent=copy.no_results_help;summary.append(help);}
    p.querySelector('[data-mb-status]').textContent=resultLabel(copy,rows.length);
    p.querySelector('[data-mb-apply]').disabled=false;
    wrapper.dataset.mbRefined='1';
  }
  async function refine(root,params,signal) {
    const p=panel(root);if(!p)return;
    // A saved amount is meaningful only in its original presentment currency.
    if(params.get(PREFIX+'currency') && params.get(PREFIX+'currency')!==p.dataset.currency){params.delete(PREFIX+'price_min');params.delete(PREFIX+'price_max');}
    params.set(PREFIX+'currency',p.dataset.currency);fill(p,params);
    if(!active(params)){p.querySelector('[data-mb-apply]').disabled=false;p.querySelector('[data-mb-status]').textContent='';return;}
    const r=ranges(params);
    if(p.dataset.pageType==='search'){
      if(!['price-ascending','price-descending'].includes(params.get('sort_by')))params.set('sort_by','price-ascending');
      const sort=params.get('sort_by');
      root.querySelectorAll('select[name=sort_by]').forEach(select=>{select.querySelectorAll('option[value=relevance]').forEach(o=>o.remove());for(const o of select.options){o.selected=o.value===sort;if(o.selected)o.setAttribute('selected','');else o.removeAttribute('selected');}select.value=sort;});
      root.querySelectorAll('input[name=sort_by]').forEach(input=>{input.value=sort;input.setAttribute('value',sort);});
    }
    const data=await allRows(params,p,signal);
    const dimensionsActive=['l','w','h'].some(a=>r[a].min!==null||r[a].max!==null);
    const dims=dimensionsActive?await index(p,signal):{};
    if(signal?.aborted)throw new DOMException('Aborted','AbortError');
    const rows=data.rows.filter(row=>matches(row,r,dims));
    render(root,rows,p,r,params,data.key+'/'+boundKeys.map(k=>params.get(k)||'').join('/'));
  }
  function apply(p,clear=false) {
    const form=p.closest('form'), params=new URLSearchParams();
    for(const input of p.querySelectorAll('[data-mb-axis]')){
      if(clear)input.value='';params.set(input.name,input.value);
    }
    try{ranges(params);}catch(e){error(p,e.message);p.querySelector('[data-mb-error]').scrollIntoView({block:'nearest'});return;}
    p.querySelector('input[name=mb_range_currency]').value=p.dataset.currency;
    ownApplyPending=true;loading(p);form.dispatchEvent(new CustomEvent('xtra:apply-filters'));
  }
  function refreshCards(){['ratings','semanticInput','semanticSelect','schemeTooltip','popups','productcardVariants','listCollectionSlider','check_limit','heightLimit'].forEach(name=>window.dispatchEvent(new CustomEvent(name)));if(typeof ajaxCart!=='undefined')ajaxCart.init();if(typeof quickShop!=='undefined')quickShop.init();}
  function localizeNativeCloses(){
    const p=panel();if(!p)return;const copy=words(p),form=p.closest('form');
    form.querySelectorAll('a.f8fl-toggle').forEach(a=>{a.setAttribute('aria-label',copy.close);a.setAttribute('title',copy.close);});
    form.querySelectorAll('a.header-toggle').forEach(a=>{const label=Array.from(a.parentElement.childNodes).filter(n=>n!==a).map(n=>n.textContent).join('').trim();if(label)a.setAttribute('aria-label',label);});
    const close=document.querySelector('#root > button.overlay-close');if(!close)return;
    if(document.documentElement.classList.contains('f8fl-open')){
      if(!overlayLabels.has(close))overlayLabels.set(close,{'aria-label':close.getAttribute('aria-label'),title:close.getAttribute('title')});
      close.setAttribute('aria-label',copy.close);close.setAttribute('title',copy.close);
    }else if(overlayLabels.has(close)){
      for(const [name,value]of Object.entries(overlayLabels.get(close)))if(value===null)close.removeAttribute(name);else close.setAttribute(name,value);
      overlayLabels.delete(close);
    }
  }
  document.addEventListener('click',()=>queueMicrotask(localizeNativeCloses));
  document.addEventListener('keyup',()=>queueMicrotask(localizeNativeCloses));
  // Native overlays change the HTML class after their click handler has returned.
  const filterClassObserver=new MutationObserver(()=>queueMicrotask(localizeNativeCloses));
  filterClassObserver.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  function boot() {
    const params=new URLSearchParams(location.search);
    document.querySelectorAll('[data-mb-ranges]').forEach(p=>{
      if(bound.has(p))return;bound.add(p);fill(p,params);
      p.addEventListener('change',e=>{if(e.target.matches('[data-mb-axis]'))e.stopPropagation();},true);
      p.addEventListener('keydown',e=>{if(e.key==='Enter' && e.target.matches('[data-mb-axis]')){e.preventDefault();e.stopPropagation();apply(p);}},true);
      p.querySelector('[data-mb-apply]').addEventListener('click',()=>apply(p));
      p.querySelector('[data-mb-clear]').addEventListener('click',()=>apply(p,true));
    });
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-mb-more]');if(!button)return;
    const wrapper=button.closest('.collection-wrapper'), data=cache.get(wrapper.dataset.mbFilteredKey);
    if(!data){showError();return;}
    const visible=Number(wrapper.dataset.mbVisible), next=Math.min(visible+48,data.rows.length);
    wrapper.querySelector('#collection').insertAdjacentHTML('beforeend',data.rows.slice(visible,next).map(r=>r.html).join(''));
    wrapper.dataset.mbVisible=next; if(next>=data.rows.length)button.remove();refreshCards();
  });
  function showError(){ownApplyPending=false;const p=panel();if(p)error(p,'load_error');}
  function accepted(){if(ownApplyPending){ownApplyPending=false;if(document.documentElement.classList.contains('f8fl-open')){const close=document.querySelector('#filter a.f8fl-toggle');if(close)close.click();}}}
  window.addEventListener('initFilters',boot);
  window.addEventListener('filters',()=>queueMicrotask(localizeNativeCloses));
  function cancelInitial(){initialGeneration++;if(initialController)initialController.abort();initialController=null;}
  async function initial(){boot();const p=panel();if(!p||!active(new URLSearchParams(location.search)))return;const generation=++initialGeneration, root=p.closest('.shopify-section');initialController=new AbortController();loading(p);try{const params=new URLSearchParams(location.search);await refine(root,params,initialController.signal);if(generation!==initialGeneration)return;if(params.toString()!==new URLSearchParams(location.search).toString())history.replaceState(history.state,'',location.pathname+'?'+params.toString());refreshCards();}catch(e){if(e.name!=='AbortError')showError();}}
  window.MBRangeFilters={refine,showError,cancelInitial,accepted,number,ranges,matches};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initial,{once:true});else initial();
})();
